module.exports = __webpack_public_path__ + "img/2.2cd8d971.jpg";